import { apiRequest } from './api';
import { Stream, StreamRequest } from '../types/stream';

export const streamService = {
  // Get all streams
  getAllStreams: async (): Promise<Stream[]> => {
    return await apiRequest<Stream[]>('/streams');
  },

  // Get streams within a date range
  getStreamsByDateRange: async (from: Date, to: Date): Promise<Stream[]> => {
    const fromISO = from.toISOString();
    const toISO = to.toISOString();
    return await apiRequest<Stream[]>(`/streams?from=${fromISO}&to=${toISO}`);
  },

  // Get stream by ID
  getStreamById: async (id: number): Promise<Stream> => {
    return await apiRequest<Stream>(`/streams/${id}`);
  },

  // Create new stream
  createStream: async (stream: StreamRequest): Promise<Stream> => {
    return await apiRequest<Stream>('/streams/create', {
      method: 'POST',
      body: JSON.stringify(stream)
    });
  },

  // Update existing stream
  updateStream: async (id: number, stream: StreamRequest): Promise<Stream> => {
    return await apiRequest<Stream>(`/streams/${id}`, {
      method: 'PUT',
      body: JSON.stringify(stream)
    });
  },

  // Delete stream
  deleteStream: async (id: number): Promise<void> => {
    return await apiRequest<void>(`/streams/${id}`, {
      method: 'DELETE'
    });
  },

  // Start stream immediately
  startStream: async (id: number): Promise<Stream> => {
    return await apiRequest<Stream>(`/streams/${id}/start`, {
      method: 'POST'
    });
  },

  // Stop stream immediately
  stopStream: async (id: number): Promise<Stream> => {
    return await apiRequest<Stream>(`/streams/${id}/stop`, {
      method: 'POST'
    });
  }
}; 